const isValidTwoPointDecimalNumber = string => {
  var regex = new RegExp(/^[0-9]+(\.[0-9]{1,2})?$/, "g");
  return regex.test(string);
};

export default isValidTwoPointDecimalNumber;
